import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-html5",
  "use": "icon-html5-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-html5\">\n<path d=\"M3.1889 2H20.8111L19.2222 20L12 22L4.77779 20L3.1889 2Z\" fill=\"#E44D26\" />\n<path d=\"M12 18.1778L16.5222 16.9222L17.1333 10.1444H9.0889L8.8889 7.88889H17.3333L17.5556 5.67778H6.44446L7.06668 12.3556H14.7222L14.4667 15.2222L12 15.8889L9.53335 15.2222L9.37779 13.3778H7.15557L7.47779 16.9222L12 18.1778Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol